import { CountUp } from 'countup.js';

const countup = document.querySelectorAll('.price-price');
for( var i=0; i< countup.length; i++ ) {
    countup[i].setAttribute('id', 'price-price-' + i);
    const thisCountUp = document.getElementById('price-price-' + i);
    const number = thisCountUp.innerText 
    const countUp = new CountUp(thisCountUp, number, { enableScrollSpy: true, scrollSpyOnce: true, decimalPlaces: 2, });
}